import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { getLocalPaymentMode } from "../../utils/localStorage";

const AdvancePaymentCollection = ({
  storeCustomerId,
  storeId,
  storeUserId,
  grandTotal,
  onSubmit,
  enabledAmountRoundOff,
}) => {
  const [selectedItem, setSelectedItem] = useState(false);
  const [receiveAmountValue, setReceiveAmountValue] = useState("");
  const [paymentMethodValue, setPaymentMethodValue] = useState(null);
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [paymentError, setPaymentError] = useState("");
  const [receiveAmountError, setReceiveAmountError] = useState("");

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);

  const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    if (paymentMode && Object.keys(paymentMode).length > 0) {
      setPaymentModeData(paymentMode?.paymentModeList?.Location1?.filter((item) => item !== "USER_ACCOUNT"));
    } else {
      setPaymentModeData([]);
    }
  };

  useEffect(() => {
    fetchLocalPaymentMode();
  }, []);

  const resetFields = () => {
    setReceiveAmountValue("");
    setPaymentMethodValue(null);
    setPaymentError("");
    setReceiveAmountError("");
  };

  useEffect(() => {
    resetFields();
  }, [grandTotal]);

  useEffect(() => {
    onSubmit({
      storeUserId,
      storeCustomerId,
      receiveAmountValue,
      paymentMethodValue,
      receiveAmountError,
      paymentError,
    });
  }, [receiveAmountValue, paymentMethodValue, paymentError, receiveAmountError]);

  const handleItemPress = () => setSelectedItem((prev) => !prev);

  const handleReceiveAmountChange = (text) => {
    if (text === "") {
      setReceiveAmountValue("");
      setPaymentError("");
      if (paymentMethodValue !== null) {
        setReceiveAmountError("Please Enter Receive Amount");
      }
      return;
    }

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;

    const numericValue = parseFloat(text);

    if (!isNaN(numericValue) && numericValue > parseFloat(grandTotal)) {
      setReceiveAmountValue("");
      setPaymentError("");
      if (paymentMethodValue) {
        setReceiveAmountError("Amount cannot exceed grand total");
      }
      return;
    }

    const finalValue = isRoundOffMode ? String(Math.round(numericValue)) : text;

    setReceiveAmountValue(finalValue);

    if (numericValue > 0) {
      setReceiveAmountError("");
      setPaymentError(!paymentMethodValue ? "Please select any Payment Method" : "");
    } else {
      setReceiveAmountError("");
    }
  };

  const handlePaymentMethodChange = (charge) => {
    setPaymentMethodValue(charge);
    setPaymentError("");
    if (!receiveAmountValue || receiveAmountValue === "0") {
      setReceiveAmountError("Please Enter Receive Amount");
    } else {
      setReceiveAmountError("");
    }
  };

  const handlePaymentMethodRemove = () => {
    setPaymentMethodValue(null);
    if (parseFloat(receiveAmountValue) > 0) {
      setReceiveAmountError("");
      setPaymentError("Please select any Payment Method");
    } else {
      setReceiveAmountError("");
      setPaymentError("");
    }
  };

  return (
    <div
      className="flex-1 shadow-2 px-3 mb-2"
      style={{ backgroundColor: "#F6FAFF" }}
    >
      <div
        className="flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
        onClick={handleItemPress}
      >
        <div className="flex justify-content-start align-items-center flex-1">
          <img
            src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
            alt="collect advance"
            style={{ width: 20, height: 20 }}
          />
          <p className="text-lg font-medium capitalize ml-2">
            Collect Advance Payment
          </p>
        </div>
        <i
          className={selectedItem ? "pi pi-angle-up" : "pi pi-angle-down"}
          style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
        />
      </div>

      {selectedItem && (
        <div className="border-top-2" style={{ borderTopColor: "#C1C9D3" }}>

          <div className="mt-3">
            <div className="flex">
              <div className="flex-1 mx-2 mb-1">
                <div className="border-round-xl shadow-2" style={{ backgroundColor: "#fff" }}>
                  <Dropdown
                    value={paymentMethodValue}
                    onChange={(e) => handlePaymentMethodChange(e.value)}
                    options={paymentModeData}
                    placeholder="Payment Method"
                    className="w-full bg-white-alpha-20 text-2xl text-primary-50"
                  />
                </div>
              </div>
              <div
                className="mx-2 mb-1 flex justify-content-center align-items-center border-round-md shadow-2 cursor-pointer"
                style={{ flex: 0.1, backgroundColor: "red" }}
                onClick={handlePaymentMethodRemove}
              >
                <p className="text-4xl text-white font-medium capitalize">X</p>
              </div>
            </div>
            {paymentError !== "" && (
              <p className="text-lg font-medium capitalize" style={{ color: "red" }}>
                {paymentError}
              </p>
            )}
          </div>

          <div className="flex-1 mx-2 pb-2 mt-3">
            <div className="border-round-xl shadow-2" style={{ backgroundColor: "#fff" }}>
              <InputText
                placeholder="Receive Amount"
                value={receiveAmountValue}
                maxLength={50}
                onChange={(e) => handleReceiveAmountChange(e.target.value)}
                keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                className="w-full border-none px-3 text-md"
              />
            </div>
            {receiveAmountError !== "" && (
              <p
                className="text-lg font-medium capitalize"
                style={{ color: "red", marginTop: 5, marginBottom: 10 }}
              >
                {receiveAmountError}
              </p>
            )}
          </div>

        </div>
      )}
    </div>
  );
};

export default AdvancePaymentCollection;